import { deltaTone, toneClass } from '../../lib/delta'

import type { GisLens } from '../../api/types'

interface DeltaBadgeProps {
  lens: GisLens
  delta: number | null
  /** Optional leading label, e.g. "Coverage". */
  label?: string
}

/**
 * Coloured period-over-period delta for white-background surfaces (the Overview verdict strip).
 * The arrow follows the sign of the change (zero is the neutral →); the colour follows `deltaTone`
 * (so a *drop* in active issues is green, a rise is red, no change is grey). On the coloured hero
 * card use the plain-string `deltaBadgeText` instead — red/green would not read against the gradient.
 */
export function DeltaBadge({ lens, delta, label }: DeltaBadgeProps) {
  const tone = deltaTone(lens, delta)
  const unit = lens === 'issues' ? '' : '%'
  const text =
    delta === null
      ? '—'
      : delta === 0
        ? `→ 0${unit}`
        : `${delta > 0 ? '▲' : '▼'} ${delta > 0 ? '+' : ''}${delta}${unit}`
  return (
    <span className="text-[11px] font-bold">
      {label && <span className="text-muted-text font-extrabold uppercase">{label} </span>}
      <span className={toneClass(tone)}>{text}</span>
    </span>
  )
}
